import type { SnapshotContents } from './api';

/** One line naming what the backup holds, counts first, nothing that is empty. */
export function snapshotHoldsLine(c: SnapshotContents): string {
  const n = (count: number, one: string, many: string) =>
    `${count.toLocaleString()} ${count === 1 ? one : many}`;
  const parts = [
    `${n(c.graphs, 'graph', 'graphs')} with ${n(c.statements, 'statement', 'statements')}`,
  ];
  if (c.prefixes > 0) parts.push(n(c.prefixes, 'prefix', 'prefixes'));
  if (c.rules > 0)
    parts.push(`${n(c.rules, 'rule', 'rules')}${c.rules_off > 0 ? ` (${c.rules_off} off)` : ''}`);
  if (c.corrections > 0) parts.push(n(c.corrections, 'correction', 'corrections'));
  for (const s of c.state) parts.push(`${s.rows.toLocaleString()} ${s.label}`);
  return parts.join(', ');
}
